"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  CtaRow: true
};
exports.CtaRow = void 0;
var _ctaRow = _interopRequireDefault(require("./components/cta-row"));
exports.CtaRow = _ctaRow["default"];
var _ctaRow2 = require("./components/cta-row.propTypes");
Object.keys(_ctaRow2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ctaRow2[key]) return;
  exports[key] = _ctaRow2[key];
});